"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Star, Quote } from "lucide-react";
const testimonials = [{
  name: "Joshua H.",
  date: "OCTOBER 2024",
  rating: 5,
  text: "Excellent service. They fixed my lawn mower quickly and it's running better than ever. Highly recommend for any equipment repairs in Carlisle."
}, {
  name: "William S.",
  date: "SEPTEMBER 2024",
  rating: 5,
  text: "Very professional team. My garden tractor needed a major service and they handled it perfectly. Great communication throughout the process."
}, {
  name: "Damian C.",
  date: "AUGUST 2024",
  rating: 5,
  text: "Top notch repair work on my petrol mower. Fair pricing and very knowledgeable staff. The best place in Cumbria for mower maintenance."
}];
export default function CustomerTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1024" id="customer-testimonials" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary rounded-lg blur-3xl" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-primary rounded-lg blur-3xl" />
      </div>

      <div ref={ref} className="page-container relative z-10">
        <div className="flex flex-col items-center mb-16 transition-all duration-1000" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 text-primary text-xs font-bold tracking-wider uppercase mb-4">
            <Star className="size-3 fill-primary" />
            <span>Testimonials</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center mb-6">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-center max-w-2xl text-lg">
            We take pride in our work and the relationships we build with our customers across Carlisle and Cumbria.
          </p>
        </div>

        <div className="relative">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                  <div className="h-full bg-card border border-border p-8 rounded-lg shadow-md flex flex-col transition-all duration-300 hover:shadow-lg hover:border-primary/20 group">
                    <div className="flex items-center justify-between mb-6">
                      <div className="flex gap-0.5">
                        {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} className="size-4 fill-primary text-primary" />)}
                      </div>
                      <Quote className="size-8 text-primary/20 group-hover:text-primary/40 transition-colors" />
                    </div>

                    <blockquote className="flex-grow mb-8">
                      <p className="text-foreground/90 leading-relaxed italic">
                        "{testimonial.text}"
                      </p>
                    </blockquote>

                    <div className="pt-6 border-t border-border/50">
                      <div className="font-bold text-foreground">{testimonial.name}</div>
                      <div className="text-xs text-muted-foreground tracking-widest uppercase mt-1">
                        {testimonial.date}
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            <div className="flex items-center justify-center gap-4 mt-12">
              <CarouselPrevious className="static translate-y-0 h-12 w-12 rounded-lg border-border bg-card hover:bg-primary hover:text-primary-foreground transition-all shadow-sm" />
              <CarouselNext className="static translate-y-0 h-12 w-12 rounded-lg border-border bg-card hover:bg-primary hover:text-primary-foreground transition-all shadow-sm" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}